export enum AggregationOperationsEnum {
  And = 'And',
  Or = 'Or',
}

export enum AggregationOperationsInsideGroupEnum {
  BigAnd = 'BigAnd',
  BigOr = 'BigOr',
}
